import { Injectable } from '@angular/core';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { DirectoryHistoryServiceInterface } from '@zaoblako/shared/common/interfaces/directory-history-service.interface';
import type { ApprovalSchemeFindInterface } from '@zaoblako/shared/modules/catalog/dtos/approval-scheme/approval-scheme-find.dto';
import type { ApprovalSchemeItemsPageInterface } from '@zaoblako/shared/modules/catalog/dtos/approval-scheme/approval-scheme-items-page.dto';
import type { ApprovalSchemeQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/approval-scheme/approval-scheme-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApprovalSchemeService extends BaseService implements DirectoryHistoryServiceInterface {
  protected baseUrl = '/basis/catalog/approval-scheme';

  public get dropdownDescriptorUrl(): string {
    return `${this.baseUrl}/dropdown-descriptor`;
  }

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(queryParams?: ApprovalSchemeQueryInterface): Observable<ApprovalSchemeItemsPageInterface> {
    const params = queryParams ? this.objectToHttpParams(queryParams) : {};
    return this.http.get<ApprovalSchemeItemsPageInterface>(`${this.baseUrl}/items`, { params });
  }

  public findDefault(): Observable<ApprovalSchemeFindInterface> {
    return this.http.get<ApprovalSchemeFindInterface>(`${this.baseUrl}/default`);
  }

  public makeDefault(id: number): Observable<ApprovalSchemeFindInterface> {
    return this.http.patch<ApprovalSchemeFindInterface>(`${this.baseUrl}/${id}`, { isDefault: true });
  }

  public deleteDefault(id: number): Observable<ApprovalSchemeFindInterface> {
    return this.http.patch<ApprovalSchemeFindInterface>(`${this.baseUrl}/${id}`, { isDefault: false });
  }

  public restoreOne(id: number): Observable<ApprovalSchemeFindInterface> {
    return this.http.post<ApprovalSchemeFindInterface>(`${this.baseUrl}/${id}/restore`, {});
  }

  public getHistoryForOne(id: number, queryParams?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }
}
